import React from 'react';
import { ImageProps } from '.';

const SvgZigzagBiSymbol = ({ size = 21, ...props }: ImageProps): JSX.Element => {
  return (
    <svg width={size} height={(size && Math.floor(size / 0.65625)) || 32} fill='none' viewBox='0 0 21 32' {...props}>
      <path fill='#000' d='M.519 0v7.479h8.914L0 32h20.48v-7.496h-8.844L21 0H.519Z' />
    </svg>
  );
};

export default SvgZigzagBiSymbol;
